var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "500" } },
    [
      _c(
        "w-card-title",
        [
          _vm._v(
            " " + _vm._s(_vm.$ct("edit-journal", { id: _vm.journalId })) + " "
          ),
          _c("w-spacer"),
          _c(
            "w-dropdown",
            {
              attrs: {
                items: _vm.buttonBarItems,
                flat: "",
                sm: "",
                right: "",
                white: "",
                "use-link": "",
              },
              on: {
                click: function ($event) {
                  return $event()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "ellipsis-v" } })],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-input", {
                    attrs: { fancy: "", label: _vm.$ct("journal-name") },
                    model: {
                      value: _vm.toEditJournal.Name,
                      callback: function ($$v) {
                        _vm.$set(_vm.toEditJournal, "Name", $$v)
                      },
                      expression: "toEditJournal.Name",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-checkbox", {
                    attrs: {
                      value: _vm.toEditJournal.SellFriendlyNumberConfig != null,
                      label: _vm.$ct("sale-numbering"),
                    },
                    on: {
                      input: function ($event) {
                        return _vm.onSellFriendlyNumberConfigToggle($event)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-transition-slide-height",
            [
              _vm.toEditJournal.SellFriendlyNumberConfig != null
                ? _c("app-friendly-id-edit", {
                    model: {
                      value: _vm.sellNumberConfig,
                      callback: function ($$v) {
                        _vm.sellNumberConfig = $$v
                      },
                      expression: "sellNumberConfig",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-checkbox", {
                    attrs: {
                      value:
                        _vm.toEditJournal.PurchaseFriendlyNumberConfig != null,
                      label: _vm.$ct("purchase-numbering"),
                    },
                    on: {
                      input: function ($event) {
                        return _vm.onPurchaseFriendlyNumberConfigToggle($event)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-transition-slide-height",
            [
              _vm.toEditJournal.PurchaseFriendlyNumberConfig != null
                ? _c("app-friendly-id-edit", {
                    model: {
                      value: _vm.purchaseNumberConfig,
                      callback: function ($$v) {
                        _vm.purchaseNumberConfig = $$v
                      },
                      expression: "purchaseNumberConfig",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("common.cancel")) + " ")]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              on: {
                click: function ($event) {
                  return _vm.confirm()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("common.confirm")) + " ")]
          ),
        ],
        1
      ),
      _vm.askNextNumberModalData.isOpen
        ? _c("app-ask-next-number", {
            on: {
              success: function ($event) {
                return _vm.askNextNumberModalData.onSuccess($event)
              },
              failure: function ($event) {
                return _vm.askNextNumberModalData.onFailure($event)
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }